import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0x222222, 0.8);
    progressBox.fillRect(width / 2 - 160, height / 2 - 25, 320, 50);

    const loadingText = this.make.text({
        x: width / 2,
        y: height / 2 - 50,
        text: 'Cargando...',
        style: {
            font: '20px monospace',
            color: '#ffffff'
        }
    });
    loadingText.setOrigin(0.5, 0.5);

    this.load.on('progress', (value: number) => {
        progressBar.clear();
        progressBar.fillStyle(0xd4af37, 1);
        progressBar.fillRect(width / 2 - 150, height / 2 - 15, 300 * value, 30);
    });

    this.load.on('complete', () => {
        progressBar.destroy();
        progressBox.destroy();
        loadingText.destroy();
        this.generateTextures();
        this.scene.start('MenuScene');
    });
    
    // Simulate loading
    this.load.image('dummy', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==');
  }

  private generateTextures() {
    const graphics = this.make.graphics({ x: 0, y: 0 });
    
    // Sparkle
    graphics.fillStyle(0xffffff, 1);
    graphics.fillCircle(4, 4, 4);
    graphics.generateTexture('sparkle', 8, 8);
    graphics.clear();
    
    // Gold particle
    graphics.fillStyle(0xd4af37, 1);
    graphics.fillCircle(3, 3, 3);
    graphics.generateTexture('particle_gold', 6, 6);
    graphics.clear();
    
    // Confetti
    const colors = [0xff0000, 0x00ff00, 0x0000ff, 0xffff00, 0xff00ff, 0x00ffff];
    colors.forEach((color, idx) => {
        graphics.fillStyle(color, 1);
        graphics.fillRect(0, 0, 8, 8);
        graphics.generateTexture(`confetti_${idx}`, 8, 8);
        graphics.clear();
    });
  }
}
